// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license

// tslint:disable:max-line-length

import {IIconOptions, IIconSubset, registerIcons} from "@uifabric/styling";

export function initializeIcons(baseUrl = "", options?: IIconOptions): void {
    const subset: IIconSubset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none",
        },
        fontFace: {
            fontFamily: `"FabricMDL2Icons"`,
            src: `url('../Content/fabric-icons-da8faffa.woff') format('woff')`,
        },
        icons: {
            BulletedList: "\uE8FD",
            Calendar: "\uE787",
            Cancel: "\uE711",
            CheckedOutByOther12: "\uF630",
            CheckMark: "\uE73E",
            ChevronDown: "\uE70D",
            ChevronDownMed: "\uE972",
            ChevronLeft: "\uE76B",
            ChevronRight: "\uE76C",
            ChevronUpMed: "\uE971",
            ChromeClose: "\uE8BB",
            ColumnList: "\uF1EC",
            Completed: "\uE930",
            Down: "\uE74B",
            Edit: "\uE70F",
            ErrorBadge: "\uEA39",
            ExcelDocument: "\uEF73",
            FabricFolderFill: "\uF0AA",
            FileHTML: "\uF2ED",
            FolderQuery: '\uF2CD',
            Info: "\uE946",
            Lock: "\uE72E",
            Mail: "\uE715",
            More: "\uE712",
            OpenInNewTab: "\uF6AB",
            PDF: "\uEA90",
            Photo2: "\uEB9F",
            PowerPointDocument: "\uEF72",
            PublisherLogo: "\uF1ED",
            Refresh: "\uE72C",
            Search: "\uE721",
            Send: "\uE724",
            TextDocument: "\uF029",
            Up: "\uE74A",
            WordDocument: "\uEF71",
        },
    };

    registerIcons(subset, options);
}
